/* ------------------------------------------------------------------------------
 *
 *  # Device Detection Module
 *
 *  Device and touch detection functionality
 *
 * ---------------------------------------------------------------------------- */

import { DEFAULT_THEME, setTouchEnabled } from './utils.js';

// Device detection functions
export function isDeviceMode() {
    return document.body.offsetWidth <= 1024;
}

export function isTablet() {
    return document.body.offsetWidth > 767 && document.body.offsetWidth <= 1024;
}

// Set e-bigger class to the body based on mouse/touch selection
export function setBiggerSize(isTouch, isTouchReload) {
    if (isTouch) {
        document.body.classList.add('e-bigger');
        localStorage.setItem("sfPreferenceMode", "touch");
        if (isTouchReload) {
            setTouchEnabled(true);
            window.location.reload();
        }
    } else {
        document.body.classList.remove('e-bigger');
        localStorage.setItem("sfPreferenceMode", "mouse");
    }
}

// Returns the preferences mode
export function getPreferenceMode() {
    var mode = localStorage.getItem("sfPreferenceMode");
    var isTouchMode = !mode && screen.availWidth >= 2160;
    if (isTouchMode || isDeviceMode() || (mode && mode != "mouse")) {
        mode = "touch";
        setBiggerSize(true, false);
    }
    mode = !mode ? "mouse" : mode;
    return mode;
}

// Remove theme name from body classes
export function updateBodyClass(themeName) {
    if (themeName != DEFAULT_THEME) {
        document.body.classList.remove(themeName);
        document.body.classList.add(DEFAULT_THEME);
    }
}

// Render showcase function
export function renderShowCase() {
    if (!window.appGlobals?.isScrolled && document.documentElement.scrollTop > 0) {
        if (window.appGlobals) {
            window.appGlobals.isScrolled = true;
        }
    }
}
